/** Vite env → auth runtime config. Never put secrets here. */

function env(name: string, fallback = ''): string {
  const v = (import.meta.env[name] as string | undefined) ?? fallback
  return v.trim()
}

export interface AuthConfig {
  keycloakUrl: string
  realm: string
  clientId: string
}

export function getAuthConfig(): AuthConfig {
  return {
    keycloakUrl: env('VITE_KEYCLOAK_URL', 'https://keycloak.rimora.org').replace(/\/$/, ''),
    realm: env('VITE_KEYCLOAK_REALM', 'genesis'),
    clientId: env('VITE_KEYCLOAK_CLIENT_ID', 'cm-ui-console'),
  }
}

export function isOidcConfigured(cfg: AuthConfig = getAuthConfig()): boolean {
  return Boolean(cfg.keycloakUrl && cfg.realm && cfg.clientId)
}

export function oidcBase(cfg: AuthConfig = getAuthConfig()): string {
  return `${cfg.keycloakUrl}/realms/${cfg.realm}/protocol/openid-connect`
}
